<!--
 * @Author: lidan
 * @Date: 2020-10-15 16:19:26
 * @LastEditTime: 2020-12-31 11:46:54
 * @LastEditors: lidan
 * @Description: 
 * @FilePath: \e6-module-tax-service\src\e6-module-tax-service\views\paymentWaybill\components\payStatus.vue
-->
<template>
  <span class="pay-status">
    <i :class="`pay-status-icon status-${status}`"></i>
    {{ statusStr }}
  </span>
</template>

<script>
export default {
  props: {
    // 状态
    status: {
      type: [String, Number]
    },
    // 状态名称
    statusStr: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.pay-status {
  display: inline-block;

  .pay-status-icon {
    display: inline-block;
    border-radius: 50%;
    width: 8px;
    height: 8px;

    &.status-1 {
      background: #b68ee9;
    }

    &.status-2 {
      background: #8642da;
    }

    &.status-3 {
      background: #56bb24;
    }

    &.status-4 {
      background: #74b8fe;
    }

    &.status-5,
    &.status-7 {
      background: #1889fd;
    }

    &.status-6 {
      background: #e39726;
    }
    &.status--1 {
      background: #f45a5a;
    }
  }
}
</style>
